"use client";
import Image from "next/image";

import { useMediaQuery } from "@/hooks/useMediaQuery";

export default function OngoingSessionImage() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return isMobile ? (
    <Image
      src="/imgs/search-illustration-mobile.svg"
      alt="Sessão em aberto"
      width={313}
      height={216}
    />
  ) : (
    <Image
      src="/imgs/search-illustration-desktop.svg"
      alt="Sessão em aberto"
      width={490}
      height={338}
    />
  );
}
